module.exports = __webpack_public_path__ + "img/img-4.32c3dc90.png";